// FloatingButtons.jsx
import React from "react";
import "./FloatingButtons.css";

const FloatingButtons = () => {
  const phoneNumber = "7023332099";
  const whatsappNumber = "917023332099";

  return (
    <div className="floating-buttons">
      {/* Call Button - Left Side */}
      <a
        href={`tel:${phoneNumber}`}
        className="floating-btn call-btn"
        aria-label="Call us"
        target="_blank"
        rel="noopener noreferrer"
      >
        <div className="btn-content">
          <i className="fas fa-phone-alt"></i>
          <span className="btn-label">Call Now</span>
        </div>
        <div className="pulse-ring"></div>
        <div className="pulse-ring delay-1"></div>
        <div className="pulse-ring delay-2"></div>
      </a>

      {/* WhatsApp Button - Right Side */}
      <a
        href={`https://wa.me/${whatsappNumber}`}
        className="floating-btn whatsapp-btn"
        aria-label="Chat on WhatsApp"
        target="_blank"
        rel="noopener noreferrer"
      >
        <div className="btn-content">
          <i className="fab fa-whatsapp"></i>
          <span className="btn-label">WhatsApp</span>
        </div>
        <div className="pulse-ring"></div>
        <div className="pulse-ring delay-1"></div>
        <div className="pulse-ring delay-2"></div>
      </a>
    </div>
  );
};

export default FloatingButtons;